import React, { useEffect, useState } from 'react';
import { get, post, put, del } from '../utils/api';

function CatModal({ cat, onClose, onSave }) {
  const [form, setForm] = useState(cat || { name:'', description:'', is_active:1 });
  const [err, setErr] = useState('');
  const save = async () => {
    if (!form.name.trim()) return setErr('Введите название');
    try {
      if (cat?.id) await put(`/categories/${cat.id}`, form);
      else await post('/categories', form);
      onSave();
    } catch(e) { setErr(e.message); }
  };
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:420}}>
        <div className="modal-title">{cat?.id ? 'Редактировать категорию' : 'Новая категория'}</div>
        {err && <div className="error-msg" style={{marginBottom:16}}>{err}</div>}
        <div className="form-grid cols-1">
          <div className="form-group"><label>Название *</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Коммунальные платежи" autoFocus/></div>
          <div className="form-group"><label>Описание</label><textarea value={form.description||''} onChange={e=>setForm({...form,description:e.target.value})} placeholder="Описание категории..."/></div>
          <div className="form-group"><label>Статус</label>
            <select value={form.is_active} onChange={e=>setForm({...form,is_active:parseInt(e.target.value)})}>
              <option value={1}>Активна</option><option value={0}>Скрыта</option>
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" onClick={save}>Сохранить</button>
        </div>
      </div>
    </div>
  );
}

function UtilityTypeModal({ item, onClose, onSave }) {
  const [name, setName] = useState(item?.name || '');
  const [isActive, setIsActive] = useState(item?.is_active ?? 1);
  const [err, setErr] = useState('');
  const save = async () => {
    if (!name.trim()) return setErr('Введите название');
    try {
      if (item?.id) await put(`/utility-types/${item.id}`, { name, is_active: isActive });
      else await post('/utility-types', { name });
      onSave();
    } catch(e) { setErr(e.message); }
  };
  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:380}}>
        <div className="modal-title">{item?.id ? 'Редактировать вид' : 'Новый вид услуги'}</div>
        {err && <div className="error-msg" style={{marginBottom:16}}>{err}</div>}
        <div className="form-grid cols-1">
          <div className="form-group"><label>Название *</label><input value={name} onChange={e=>setName(e.target.value)} placeholder="Электроэнергия" autoFocus/></div>
          {item?.id && (
            <div className="form-group"><label>Статус</label>
              <select value={isActive} onChange={e=>setIsActive(parseInt(e.target.value))}>
                <option value={1}>Активен</option><option value={0}>Скрыт</option>
              </select>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" onClick={save}>Сохранить</button>
        </div>
      </div>
    </div>
  );
}

export default function CategoriesPage() {
  const [cats, setCats] = useState([]);
  const [modal, setModal] = useState(null);
  const [utilTypes, setUtilTypes] = useState([]);
  const [utilModal, setUtilModal] = useState(null);

  const loadCats = () => get('/categories').then(setCats).catch(()=>{});
  const loadUtilTypes = () => get('/utility-types').then(setUtilTypes).catch(()=>{});

  useEffect(() => { loadCats(); loadUtilTypes(); }, []);

  const removeUtilType = async (item) => {
    if (!window.confirm(`Удалить «${item.name}»?`)) return;
    try { await del(`/utility-types/${item.id}`); loadUtilTypes(); }
    catch(e) { alert(e.message); }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Справочники</h1>
      </div>
      <div style={{maxWidth:600}}>

        {/* Expense categories */}
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
          <div className="section-title">Группы затрат (категории расходов)</div>
          <button className="btn btn-primary btn-sm" onClick={()=>setModal({})}>+ Добавить</button>
        </div>
        <p style={{fontSize:13,color:'var(--text3)',marginBottom:16}}>Используются при добавлении расходных транзакций и в отчёте P&L.</p>
        <div className="card" style={{marginBottom:32}}>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Название</th><th>Описание</th><th>Статус</th><th></th></tr></thead>
              <tbody>
                {cats.length===0 && <tr><td colSpan={4} style={{textAlign:'center',color:'var(--text3)',padding:30}}>Нет категорий</td></tr>}
                {cats.map(c=>(
                  <tr key={c.id}>
                    <td style={{fontWeight:600}}>{c.name}</td>
                    <td style={{color:'var(--text3)',fontSize:13}}>{c.description||'—'}</td>
                    <td><span className={`badge ${c.is_active?'badge-green':'badge-gray'}`}>{c.is_active?'Активна':'Скрыта'}</span></td>
                    <td><button className="btn btn-ghost btn-sm" onClick={()=>setModal(c)}>✏️</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Utility types */}
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
          <div className="section-title">Виды коммунальных услуг</div>
          <button className="btn btn-primary btn-sm" onClick={()=>setUtilModal({})}>+ Добавить</button>
        </div>
        <p style={{fontSize:13,color:'var(--text3)',marginBottom:16}}>Используются в транзакциях и импорте Т-Банк при выборе вида коммунальной услуги.</p>
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead><tr><th>Название</th><th>Статус</th><th></th></tr></thead>
              <tbody>
                {utilTypes.length===0 && <tr><td colSpan={3} style={{textAlign:'center',color:'var(--text3)',padding:30}}>Нет видов услуг</td></tr>}
                {utilTypes.map(u=>(
                  <tr key={u.id}>
                    <td style={{fontWeight:600}}>{u.name}</td>
                    <td><span className={`badge ${u.is_active?'badge-green':'badge-gray'}`}>{u.is_active?'Активен':'Скрыт'}</span></td>
                    <td style={{display:'flex',gap:6}}>
                      <button className="btn btn-ghost btn-sm" onClick={()=>setUtilModal(u)}>✏️</button>
                      <button className="btn btn-ghost btn-sm" style={{color:'var(--red)'}} onClick={()=>removeUtilType(u)}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {modal!==null && <CatModal cat={modal.id?modal:null} onClose={()=>setModal(null)} onSave={()=>{setModal(null);loadCats();}}/>}
      {utilModal!==null && <UtilityTypeModal item={utilModal.id?utilModal:null} onClose={()=>setUtilModal(null)} onSave={()=>{setUtilModal(null);loadUtilTypes();}}/>}
    </div>
  );
}
